import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Used specifially in the workflow ui to help set the hlm tabs persistentally
 * as config changes and causes rerenders
 *
 * This breaks the functionality of two tabs on one page so this needs to be accounted for in designs
 * and this service shouldn't be included in the web frontend and is optional
 */
@Injectable({
  providedIn: 'root',
})
export class HlmTabsService {
  activeTabSubjects = new Map<string, Subject<string>>();
  activeTabUpdates = new Subject<[string, string]>();

  public setActiveTab(key: string, index: string) {
    if (!this.activeTabSubjects.get(key)) {
      this.activeTabSubjects.set(key, new BehaviorSubject<string>('0'));
    }
    this.activeTabSubjects.get(key)?.next(index);
    this.activeTabUpdates.next([key, index]);
  }
}
